import { render, staticRenderFns } from "./AssignDocument.vue?vue&type=template&id=28ea19b4&scoped=true"
import script from "./AssignDocument.vue?vue&type=script&lang=js"
export * from "./AssignDocument.vue?vue&type=script&lang=js"
import style0 from "./AssignDocument.vue?vue&type=style&index=0&id=28ea19b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ea19b4",
  null
  
)

export default component.exports